<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-4 float-left">
            <h1 class="page-title" *ngIf="router.url == '/gp-leads'">GP Leads</h1>
            <h1 class="page-title" *ngIf="router.url == '/leads'">Leads</h1>
            <h1 class="page-title" *ngIf="router.url == '/px-leads'">PX Leads</h1>
        </div>
        <div class="col-sm-8 float-left add_lead_btn">
            <div class="row" *ngIf="router.url == '/leads'">
                <div class="col-sm-3">
                    <span *ngIf="userId=='89' || userId=='167'">
                    <!-- <span *ngIf="myrole=='1'"> -->
                        <div><button [disabled]="loading" class="float-right btn btn-success text-white" (click)="showModalLeadDump()">Lead Dump</button><br></div> <br>
                    </span>
                </div>

                <div class="col-sm-3">
                    <!-- Import FB leads -->
                    <span *ngIf="myrole=='1'">
                        <div><a class="float-right btn btn-success text-white" (click)="showModal()"><i class="fa fa-file-excel"></i> Import Leads</a><br></div> <br>
                        
                        <!-- <a href="{{s3url}}crm/lead-sample-import.csv" target="_blank">Sample CSV</a> -->
                    </span>
                </div>

                  <!-- Update leads Status -->
                <div class="col-sm-3">
                    <span *ngIf="myrole=='1'">
                        <div><a class="float-right btn btn-success text-white" (click)="showLeadStatusUpdateModal()"><i class="fa fa-file-excel"></i> Update Dental Leads Status</a><br></div> <br>
                        
                        <a href="{{s3url}}crm/lead-status-update-sample-import.csv" target="_blank">Sample CSV</a>
                    </span>
                </div>

                <div class="col-sm-3">
                    <!-- Import FB leads -->
                    <!-- <span *ngIf="myrole=='1'">
                        <div><a class="float-right btn btn-success text-white" (click)="showModalPartners()"><i class="fa fa-file-excel"></i> Import Partner Leads</a><br></div> <br>
                       </span> -->
                </div>
                 <!-- Import FB leads -->
                <!-- <div class="col-sm-3">
                   <span *ngIf="myrole=='1' && userId=='89'">
                        <div><a class="float-right btn btn-success text-white" (click)="showModalFb()"><i class="fa fa-file-excel"></i> Import Fb Leads</a><br></div> <br>
                        
                        <a href="{{s3url}}crm/sample-fb-import.csv" target="_blank">Sample CSV for fb</a>
                    </span>
                </div> -->

                <div class="col-sm-3">
                    <span *ngIf="myrole=='1' && userId=='89'">
                         <div><a class="float-right btn btn-success text-white" (click)="showOtherLeads()"><i class="fa fa-file-excel"></i> Import others Leads</a><br></div> <br>
                         
                         <!-- <a href="{{s3url}}crm/sample-fb-import.csv" target="_blank">Sample CSV for fb</a> -->
                     </span>
                 </div>

                <div class="col-sm-3">
                    <span *ngIf="myrole=='1' && userId=='89'">
                         <div><a class="float-right btn btn-success text-white" (click)="showfollowupModal()"><i class="fa fa-file-excel"></i> Update follow-up date</a><br></div> <br>
                     </span>
                 </div>

                <!-- <div class="col-sm-3">
                    <a *ngIf="myrole=='1' || (myrole=='4' && (userId=='19' || userId=='49')) || (myrole=='3' && isCMAccess=='1') || myrole=='18'" routerLink="/create-lead" class="btn btn-success mr-2">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Lead
                    </a>
                    <a *ngIf="((myrole=='14' && isCMAccess=='1') || (myrole=='16' && userId!='312'))" routerLink="/create-partner-lead" class="btn btn-success mr-2">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Lead
                    </a>
                </div> -->

                <div class="col-sm-3">
                    <a *ngIf="myrole=='1'" routerLink="/create-lead" class="btn btn-success mr-2">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Lead
                    </a>
                    
                </div>

            </div>
            <div class="row" *ngIf="router.url == '/gp-leads'">
                <div class="col-sm-6"></div>
                <div class="col-sm-6">
                    <a *ngIf="myrole=='1' || myrole=='4'" routerLink="/create-gp-lead" class="btn btn-success mr-2 pull-right">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add GP Lead
                    </a>
                </div>
            </div>
            <div class="row" *ngIf="myrole=='16' && router.url == '/partner-leads'">
                <div class="col-sm-6"></div>
                <div class="col-sm-6">
                    <a *ngIf="myrole=='16'" routerLink="/create-partner-lead" class="btn btn-success m-2 pull-right">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Lead
                    </a>
                </div>
            </div>
        </div>

    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row mb-2 mt-2">
                        <div class="col-sm-2 mt-2"><input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" /></div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='2' && router.url != '/gp-leads'  && myrole!='16'">
                            <mat-select  placeholder="Lead Source" [(ngModel)]="lead_source" (click)="setSearchValue('lead_source')" multiple>
                                <input class="mySearchInput"
                                #leadsourceSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_source')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="leadsourceSearch">
                                <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">{{lsources.source_name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Status" [(ngModel)]="lead_status" (click)="setSearchValue('lead_status')" multiple>
                                <input class="mySearchInput"
                                #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="lead_status_Search">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{lstatus.id}}" *ngFor="let lstatus of leadStatus">{{lstatus.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='3' || myrole=='4' || myrole=='6'|| myrole=='9' || myrole=='15' || myrole=='18'">
                            <mat-select  placeholder="Bds" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple #itemSelect="ngModel">
                                <input class="mySearchInput"
                                #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="bd_search">
                                <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')" multiple>
                                <input class="mySearchInput"
                                #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="circleSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Treatment" [(ngModel)]="treatment" (click)="setSearchValue('treatment')" multiple>
                                <input class="mySearchInput"
                                #treatmentSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'treatment')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="treatmentSearch">
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="{{ltreatment.id}}" *ngFor="let ltreatment of treatments">{{ltreatment.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole!='14' && myrole!='16'">
                            <mat-select  placeholder="Bridge Number" [(ngModel)]="bridgeno" (click)="setSearchValue('bridgeno')">
                                <input class="mySearchInput"
                                #bridgenoSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bridgeno')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="bridgenoSearch">
                                <mat-option >All</mat-option>
                                <mat-option value="{{bnumbers.bridge_number}}" *ngFor="let bnumbers of bridge_number_lists">{{bnumbers.bridge_number}} ({{bnumbers.bridge_name}})</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Lead Catergory" [(ngModel)]="lead_category_filter" (click)="setSearchValue('leadCategory')" multiple>
                                <input class="mySearchInput"
                                #leadcategorySearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'leadCategory')"
                                (keydown)="$event.stopPropagation()" autocomplete="off"
                                placeholder="Search"
                                id="leadcategorySearch">
                                <mat-option value="{{catergory.id}}" *ngFor="let catergory of treatCategory">{{catergory.name}}</mat-option>
                            </mat-select>
                        </div>
                        <!-- <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='6'">
                            <mat-select  placeholder="Catergory wise" (selectionChange)="loadleads(0,perpage)" [(ngModel)]="category_filter">
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='6'">
                            <mat-select  placeholder="Catergory wise"  [(ngModel)]="category_filter">
                                <mat-option>All</mat-option>
                                <mat-option value="2">PCLC</mat-option>
                                <mat-option value="3">VODKA</mat-option>
                                <mat-option value="4">Dental</mat-option>
                            </mat-select>
                        </div> -->
                        <div class="col-sm-2 mt-2">
                            <mat-select  placeholder="Payment Mode"  [(ngModel)]="payment_mode" multiple>
                                <!-- <mat-option >All</mat-option> -->
                                <mat-option value="Cash">Cash</mat-option>
                                <mat-option value="Cashless">Cashless</mat-option>
                                <mat-option value="Reimbursement">Reimbursement</mat-option>
                                <mat-option value="EMI">EMI</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2">
                            <mat-select placeholder="Gender"  [(ngModel)]="gender">
                                <mat-option value="">All</mat-option>
                                <mat-option value="Male">Male</mat-option>
                                <mat-option value="Female">Female</mat-option>
                            </mat-select>
                        </div>

                        <div class="col-sm-2 mt-2" *ngIf="myrole!='16'">
                            <mat-select  placeholder="Pre-Sales Users" [(ngModel)]="pre_sale_users_filter" multiple>
                                <!-- <mat-option value="">All</mat-option> -->
                                <mat-option value="{{psu.id}}" *ngFor="let psu of allpre_sale_users">{{psu.name}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-2 mt-2" *ngIf="myrole=='1' || myrole=='6'">
                            <mat-select placeholder="Marketing Remarks"  [(ngModel)]="marketing_remarks" multiple>
                                <mat-option value="DNP-Sep-Oct">DNP Sep-Oct</mat-option>
                                <mat-option value="DNP-Nov-Dec">DNP Nov-Dec</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div class="row">
                        
                        <div class="col-sm-3 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate #dateRangeStart placeholder="Start date">
                                    <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDate()">clear</mat-icon>
                        </div>
                        <div class="col-sm-3 mt-2" *ngIf="myrole!='16'">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter Follow-Up date range</mat-label>
                                <mat-date-range-input [rangePicker]="picker1">
                                    <input matStartDate #followupdateRangeStart placeholder="Start date">
                                    <input matEndDate #followupdateRangeEnd placeholder="End date" (dateChange)="dateRangeChangefollowUp(followupdateRangeStart, followupdateRangeEnd)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker1></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon (click)="clearDateFollowUp()">clear</mat-icon>
      
                            </div>

                        <div class="float-right mt-6" *ngIf="myrole!='14' && myrole!='16'">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="showopdDonebutIpdNotDone">
                                <span class="custom-control-label">Show Opd done but Ipd not done</span>
                              </label>
                        </div>
                        <div class="col-sm-2 mt-6" *ngIf="myrole=='1' || myrole=='3' || myrole=='6' || myrole=='18'">
                          <label class="custom-control custom-checkbox">
                              <input type="checkbox" class="custom-control-input"  [(ngModel)]="displayInactiveUsersLead" />
                              <span class="custom-control-label">Display Inactive Users Lead</span>
                          </label>
                       </div>
                       <div class="col-sm-2 mt-4" *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access=='1')">
                        <mat-select  placeholder="Mdspok" [(ngModel)]="mdspok" (click)="setSearchValue('mdspok')">
                            <input class="mySearchInput"
                            #mdspokSearch focused="'true'" type="text"
                            (keyup)="searchOnSelect($event.target.value, 'mdspok')"
                            (keydown)="$event.stopPropagation()" autocomplete="off"
                            placeholder="Search"
                            id="mdspokSearch">
                            <mat-option value="{{mdspok.id}}" *ngFor="let mdspok of mdSpokData">{{mdspok.name}}</mat-option>
                        </mat-select>
                    </div>
                       <div class="col-sm-3 mt-2">
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadleads(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i class="fa fa-sync"></i> Reset Filters</button>
                      </div>
                      
                       
                    </div>
                </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-8 p-3"><button type="button" class="btn btn-success" [disabled]="loading" (click)="loadleads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>
            <span *ngIf="router.url != '/px-leads'">
                <button type="button" *ngIf="myrole=='1' || (myrole=='3' && is_presales_access=='1')" class="btn btn-success ml-2" [disabled]="loading" (click)="exportPartnerLeadData()"><i class="fa fa-file-excel"></i> Export List For Partner</button>

                <button type="button" *ngIf="myrole=='1' || myrole=='4' || (myrole=='3' && userId=='125')" class="btn btn-success ml-2" [disabled]="loading" (click)="exportLeadData()"><i class="fa fa-file-excel"></i> Export List</button>

                <button type="button" *ngIf="myrole=='6' || myrole=='1'" class="btn btn-success ml-2" [disabled]="loading" (click)="exportLeadDataforMatketing()"><i class="fa fa-file-excel"></i> Export List For Marketing</button>
                 
                <button type="button" *ngIf="(myrole=='1'  || myrole=='18' || myrole=='15')" class="btn btn-success ml-2" [disabled]="loading" (click)="exportTrainingLeadData()"><i class="fa fa-file-excel"></i> Export For Q&T</button>
            </span>
                 </div>
                <div class="col-sm-4"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Lead Id</th>
                        <th>Patient Id</th>
                        <th>Glamyo Patient Id</th>
                        <th *ngIf="myrole!='2'">Lead Source</th>
                        <th>Bridge Number</th>
                        <th>Lead Status</th>
                        <th>Payment Mode</th>
                        <th>Policy Number</th>
                        <th class="tablefixcoloumn">Lead Name</th>
                        <th width="100" *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access!='1')">Lead Mobile</th>
                        <th *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access!='1')">Kaleyra C2C</th>
                        <th *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access!='1')">Feedback Description</th>
                        <th>Age</th>
                        <th>Gender</th>
                        <th>Lead Location</th>
                        <th>Sub Location</th>
                        <th>Circle</th>
                        <th>Lead Owner</th>
                        <th>Employee Id</th>
                        <th>Treatment</th>
                        <th>Treatment Catergory</th>
                        <th>Pre-Sales User</th>
                        <th>Problem</th>
                        <th width="500">Description</th>
                        <th colspan="3">
                            Call Details
                        </th>
                        <th>Lead Date</th>
                        <th>Surgery Date</th>
                        <th>Follow Up Date</th>
                        <th *ngIf="myrole!='2'">Form Lead Source</th>
                        <th *ngIf="myrole!='2'">Form Ad Type</th>
                        <th *ngIf="myrole!='2'">Form GCLID</th>
                        <th *ngIf="myrole!='2'">Form Keywords</th>
                        <th *ngIf="myrole!='2'">Campaign Name</th>
                        <th *ngIf="myrole!='2'">Site</th>
                        <th *ngIf="myrole!='2'">Thumbnail</th>
                        <th *ngIf="myrole!='2'">Promo Code</th>
                        <th *ngIf="myrole!='2'">Ad GroupID</th>
                        <th *ngIf="myrole!='2'">Match Type</th>
                        <th *ngIf="myrole!='2'">MD SPOC</th>
                        <th *ngIf="myrole!='2'">MD SPOC Description</th>
                        <th *ngIf="myrole!='2'">Created By</th>
                        <th *ngIf="myrole=='1' || myrole=='6'">Marketing Remarks</th>
                        <th *ngIf="myrole!='4' && myrole!='9' && myrole!='12' && myrole!='13' && myrole!='16'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lead of leads;let index = index;" [ngClass]="{'labLeads':(lead.lead_source==7 && (lead.referral_type==6 || lead.referral_type==7))}">
                        <td >{{(pageIndex*perpage)+index+1}}</td>
                        <td>{{lead.id}}</td>
                        <td>{{lead.patient_id}}</td>
                        <td>{{lead.glamyo_patient_id}}</td>
                        <td *ngIf="myrole!='2'">
                            <span class="badge bg-green-light" *ngIf="lead.lead_source==2">{{lead.source_name}}</span>
                            <span class="badge bg-indigo-light" *ngIf="lead.lead_source!=2">{{lead.source_name}}
                            </span> <br>
                            <span  *ngIf="lead.referral_type">
                                <span>({{getRefferalType(lead.referral_type)}} - {{lead.referral_person_name}})</span> <br>
                            </span>
                        </td>
                        <td>{{lead.bridge_no}}</td>
                        <td>
                            <span class="badge bg-azure-light">{{lead.lead_status_name}}</span>
                        </td>
                        <td>{{lead.payment_mode}}</td>
                        <td>{{lead.policy_number}}</td>
                        <td class="tablefixcoloumn">{{lead.lead_name}}</td>
                        <td width="100" *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access!='1')">
                            <div style="width: 150px;">
                                <span *ngIf="!showNumberArray[index]">********** &nbsp; 
                                    <i (click)="showhideNumber('1',index)" class="fa fa-eye" aria-hidden="true" *ngIf="!showNumberArray[index]"></i>
                                    
                                </span>
                                <span *ngIf="showNumberArray[index]">
                                    {{lead.mobile}} &nbsp;
                                    <i (click)="showhideNumber('2',index)" class="fa fa-eye-slash" aria-hidden="true" *ngIf="showNumberArray[index]"></i>
                                </span>
                            </div>
                        </td>
                        <!-- {{lead.mobile}} -->
                        <td *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access!='1')"><span class='p-2 badge btn-success pointer-cur' (click)="click_to_call_function(lead.id)">Click to Call</span></td>
                        <td *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access!='1')"><span class="badge bg-green-light pointer-cur" (click)="showFeedbackDescriptionModal(lead.id,lead.feedback_description)">Add Description</span></td>
                        <td>{{lead.patient_age}}</td>
                        <td>{{lead.gender}}</td>
                        <td>{{lead.city_name}}</td>
                        <td>
                            <span *ngIf="lead.sub_location">{{lead.sub_location}}</span>
                            <span *ngIf="!lead.sub_location">-</span>
                        </td>
                        <td>{{lead.circle_name}}</td>
                        <td>{{lead.bd_name}}</td>
                        <td>{{lead.employee_id}}</td>
                        <td>{{lead.treatment_name}}</td>
                        <td>{{lead.catergoryName}}</td>
                        <td>{{lead.pre_sales_username}}</td>
                        <td>{{lead.problem}}</td>
                        <td width="500" style="display: inline-block;">{{lead.description}}</td>
                        <td colspan="3">
                            <table class="table table-bordered">
                                <tbody>
                                    <tr *ngFor="let callD of toJson(lead.call_details)">
                                        <td>
                                            <span *ngIf="lead.lead_source==2 && callD.call_start_time">{{callD.call_start_time*1000|date:'d MMM, yyyy H:m:s'}}</span>
                                            <span *ngIf="lead.lead_source==1">NA</span>
                                        </td>
                                        <td>
                                            <span *ngIf="lead.lead_source==2 && callD.call_end_time">{{callD.call_end_time*1000|date:'d MMM, yyyy H:m:s'}}</span>
                                            <span *ngIf="lead.lead_source==1">NA</span>
                                        </td>
                                        <td>
                                            <span *ngIf="lead.lead_source==2 && callD.call_recording_url"><a target="_blank" href="{{callD.call_recording_url}}">View Recording</a></span>
                                            <span *ngIf="(lead.lead_source==2 && !callD.call_recording_url) || lead.lead_source==1">NA</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td>
                            <span *ngIf="myrole=='1' || myrole=='6'">{{lead.lead_time*1000|date:'d MMM, yyyy H:m:s'}}</span> 
                            <span *ngIf="myrole!='1' && myrole!='6'">{{lead.lead_time*1000|date:'d MMM, yyyy'}}</span>
                        </td>
                        <td>
                            <span *ngIf="lead.ipd_surgery_date">{{lead.ipd_surgery_date*1000|date:'d MMM, yyyy'}}</span>
                            <span *ngIf="!lead.ipd_surgery_date">-</span>
                        </td>
                        <td>
                            <span *ngIf="lead.followup_date">{{lead.followup_date*1000|date:'d MMM, yyyy'}}</span>
                            <span *ngIf="!lead.followup_date">-</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.zoho_lead_source">{{lead.zoho_lead_source}}</span>
                            <span *ngIf="!lead.zoho_lead_source">NA</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.zoho_ad_type">{{lead.zoho_ad_type}}</span>
                            <span *ngIf="!lead.zoho_ad_type">NA</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.gclid">{{lead.gclid}}</span>
                            <span *ngIf="!lead.gclid">NA</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.keywords">{{lead.keywords}}</span>
                            <span *ngIf="!lead.keywords">NA</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.campaign_name">{{lead.campaign_name}}</span>
                            <span *ngIf="!lead.campaign_name">-</span>

                        </td>

                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.utm_site">{{lead.utm_site}}</span>
                            <span *ngIf="!lead.utm_site">-</span>

                        </td>

                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.thumbnail">{{lead.thumbnail}}</span>
                            <span *ngIf="!lead.thumbnail">-</span>

                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.promocode">{{lead.promocode}}</span>
                            <span *ngIf="!lead.promocode">-</span>

                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.utm_agid">{{lead.utm_agid}}</span>
                            <span *ngIf="!lead.utm_agid">-</span>

                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.matchtype">{{lead.matchtype}}</span>
                            <span *ngIf="!lead.matchtype">-</span>

                        </td>
                        <!-- <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.spocperson">{{lead.spocperson}}</span>
                            <span *ngIf="!lead.spocperson">-</span>

                        </td> -->
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="myrole=='1' || (myrole=='4' && is_doctor_access=='1')">
                                <span class="badge bg-green-light" *ngIf="lead.spocperson" (click)="showMdSpockDescriptionUpdateModal(lead.id,lead.md_spok_description)" style="cursor: pointer;">{{lead.spocperson}}</span>
                            </span>
                            <span *ngIf="myrole!='1' || (myrole=='4' &&  is_doctor_access!='1')">
                                <span *ngIf="lead.spocperson">{{lead.spocperson}}</span>
                            </span>
                          
                            <span *ngIf="!lead.spocperson">-</span>
                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.md_spok_description">{{lead.md_spok_description}}</span>
                            <span *ngIf="!lead.md_spok_description">-</span>

                        </td>
                        <td *ngIf="myrole!='2'">
                            <span *ngIf="lead.cb_Name">{{lead.cb_Name}}</span>
                            <span *ngIf="!lead.cb_Name">-</span>

                        </td>
                        <td *ngIf="myrole=='1' || myrole=='6'">
                            <span *ngIf="lead.marketing_remarks">{{lead.marketing_remarks}}</span>
                        </td>

                        <td  *ngIf="myrole!='4' && myrole!='9' && myrole!='12' && myrole!='13'  && myrole!='16'">
                             <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{lead.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{lead.id}}">
                                    <a class="dropdown-item" target="_blank" routerLink="/view-lead/{{lead.id}}"><i class="fa fa-eye"></i> View</a>
                                    <!-- <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Upload Insurance Card')"><i class="fa fa-file-medical"></i> Upload Insurance Card</a>
                                    <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Post OPD')"><i class="fa fa-stethoscope"></i> Post OPD</a>
                                    <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Post IPD')"><i class="fa fa-clinic-medical"></i> Post IPD</a>
                                    <a *ngIf="myrole!='6'" class="dropdown-item" (click)="getPaymentTreatmentStatus(lead.id,'Create Duplicate Lead')"><i class="far fa-copy"></i> Create Duplicate Lead</a> -->
                                    <!-- <a class="dropdown-item" href="#" routerLink="/update-lead/{{lead.id}}"><i class="fa fa-pen"></i> Update</a> -->
                                    <!-- <a *ngIf="myrole!='6'" class="dropdown-item" href="#"><i class="fa fa-trash"></i> Delete</a> -->
                                    <!-- <a class="dropdown-item" target="_blank" routerLink="/lead-details/{{lead.id}}"><i class="fa fa-eye"></i> Lead Detaiis</a> -->
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="21" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !leads.length">
                        <td colspan="21" ><i class="far fa-frown"></i> Leads not found</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


          </div>
</div>
<!-- FB import modal -->
<!-- The Modal -->
<div class="modal fade" id="myModalfb">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Fb Data </h4>
          <button type="button" class="close" (click)="hideModalFb()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadFb (change)="selectFileFb($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalFb()">Close</button>
        </div>
      </div>
    </div>
  </div>


 <!-- partners import modal -->
<!-- The Modal -->
<div class="modal fade" id="myModalpartners">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Partners Data </h4>
          <button type="button" class="close" (click)="hideModalPartner()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submittedPartners" type="file" #csvUploadPartners (change)="selectFilePartners($event)" class="form-control" />
                  </div>
                  <span *ngIf="submittedPartners"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalPartner()">Close</button>
        </div>
      </div>
    </div>
  </div> 


<!-- The Modal -->
<div class="modal fade" id="myModal">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Import Data </h4>
        <button type="button" class="close" (click)="hideModal()"></button>
      </div>

      <!-- Modal body -->
        <div class="modal-body">
            <div class="form-group">
                <div class="row">
                    <label class="col-sm-12">Upload CSV</label>
                    <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)" class="form-control" />
                </div>
                <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
            </div>
        </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn" (click)="hideModal()">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Duplicate Modal -->
<div class="modal fade" id="duplicateModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Create Duplicate Lead</h4>
          <button type="button" class="close" (click)="hideduplicateModal()"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12"><h2>Do you want to create duplicate lead?</h2></div>

                    <div *ngIf="copyData" class="col-sm-12 text-center" style="font-size: 22px;"><span><i class="fa fa-spin fa-spinner"></i> Uploading...</span></div>

                  </div>

              </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
           <button type="button" class="btn btn-success" (click)="copyLead()">Confirm</button>
          <button type="button" class="btn" (click)="hideduplicateModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

   <!--For Show Payment Mode and Treatment not Selected Modal -->
<div class="modal fade" id="paymentTreatmentModal">
    <div class="modal-dialog">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Action Required</h4>
          <button type="button" class="close" (click)="hideStatusModal()"></button>
        </div>

        <!-- Modal body -->
          <div class="modal-body">
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title" id="StatusText"><h2></h2></div>
                  </div>
                </div>
          </div>

        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideStatusModal()">Close</button>
        </div>
      </div>
    </div>
  </div>

<!--------For Lead Dump Data-------------->
<div class="modal fade" id="leadDumpData" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
            <h4 class="modal-title">Lead Dump </h4>
            <button type="button" class="close" (click)="hideModalLeadDump()"></button>
        </div>

        <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-12 text-danger"><b>Note*** : </b> Date selection should be 31 days or less than 31 days</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5 mt-2">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter a date range</mat-label>
                                <mat-date-range-input [rangePicker]="dump_picker">
                                    <input matStartDate #dateRangeStartDump placeholder="Start date">
                                    <input matEndDate #dateRangeEndDump placeholder="End date" (dateChange)="dateRangeChangeDump(dateRangeStartDump, dateRangeEndDump)">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matSuffix [for]="dump_picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #dump_picker></mat-date-range-picker>
                            </mat-form-field>
                            <mat-icon style="font-size: 20px;" (click)="clearDateDump()">clear</mat-icon>
                        </div>
                        <div class="col-sm-2 mt-4">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="export_dump_with_kalera_call">
                                <span class="custom-control-label">Export with Kalera Recording</span>
                            </label>
                        </div>
                        <div class="col-sm-2 mt-4">
                            <label class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [(ngModel)]="export_dump_with_c2c">
                                <span class="custom-control-label">Export with C2C Recording</span>
                            </label>
                        </div>
                        <div class="col-sm-2 mt-4">
                            <button  [disabled]="dump_loading" type="button" class="btn btn-success" (click)="getleaddumpByDate()">Get Export List</button>
                        </div>
                    </div>
                </div>
                <hr>
                <div *ngIf="dump_total>0">
                    <div [innerHTML]="paging_html_dump | safe:'html'"></div>
                </div>
            </div>

        <!-- Modal footer -->
        <div class="modal-footer">
            <button type="button" class="btn" (click)="hideModalLeadDump()">Close</button>
        </div>
        </div>
    </div>
</div>


<!-- The Modal For Update Leads Status -->
<div class="modal fade" id="myModalLeadStatusUpdate">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Data </h4>
          <button type="button" class="close" (click)="hideLeadStatusUpdateModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadLeadsStatusUpdate (change)="selectFileUpdateLeadStatus($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideLeadStatusUpdateModal()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-- Show Update Leads Status Data-->
<div class="modal fade" id="myModalLeadDataStatusUpdate">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Inserted Data </h4>
          <button type="button" class="close" (click)="hideDataLeadStatusUpdateModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <div class="col-sm-12">
                          <h5><span style="word-wrap: break-word;"><b>Updated LeadIds : </b>{{updatedLeadsStatus}}</span></h5>
                          <h5><span style="word-wrap: break-word;"><b>Not Updated LeadIds : </b>{{notUpdatedLeadsStatus}}</span></h5>
                      </div>
                  </div>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideDataLeadStatusUpdateModal()">Close</button>
        </div>
      </div>
    </div>
</div>


<!-- Follow-up update -->
<div class="modal fade" id="followupModal">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Update Follow Up Date </h4>
          <button type="button" class="close" (click)="hidefollowupModal()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUpdateFollowUP (change)="selectFileFollowUp($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalFb()">Close</button>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" id="myModalotherLeads">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Leads Data </h4>
          <button type="button" class="close" (click)="hideOtherLeads()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadOtherLead (change)="selectFileOtherLeads($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideOtherLeads()">Close</button>
        </div>
      </div>
    </div>
  </div>


  <!-- The Modal For Update MD spok Description -->
<div class="modal fade" id="myModalMdspockDescription">
    <form [formGroup]="descriptionForm" (submit)="saveMdspockDescription()">
        <!-- <form> -->
        <div class="modal-dialog">
        <div class="modal-content">
    
            <!-- Modal Header -->
            <div class="modal-header">
            <h4 class="modal-title">Add Description </h4>
            <button type="button" class="close" (click)="hideMdSpockDescriptionUpdateModal()"></button>
            </div>
    
            <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-sm-11" style="margin:auto ;">
                            <!-- <label for="exampleFormControlTextarea1">Enter Description</label> -->
                            <textarea class="form-control" formControlName="mdspok_description" rows="3"></textarea>
                            <div *ngIf="submitted && f.mdspok_description.errors" class="invalid-feedback">
                                <div *ngIf="f.mdspok_description.errors.required">Description is required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- Modal footer -->
            <div class="modal-footer">
                <button  type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> 
                    <span>Submit</span>    
                </button>
            <button type="button" class="btn" (click)="hideMdSpockDescriptionUpdateModal()">Close</button>
            </div>
        </div>
        </div>
    </form>
</div>
<!-----------------The Modal For Click to Call-------------------------->
<div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Progression</h4>
        </div>
          <div class="modal-body">
                <div class="alert alert-danger" *ngIf="progression_msg">
                  <strong>Warning!</strong> {{progression_msg}}
                </div>
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                      <i class="fa fa-cog fa-spin"></i><br />
                      <h2>Call is under progress.</h2>
                    </div>
                  </div>
                </div>
          </div>
        <div class="modal-footer">
          <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
        </div>
      </div>
    </div>
</div>

<!-- The Modal For Update feedback Description -->
 <div class="modal fade" id="feedbackModelDescription">
    <form [formGroup]="feedbackDescriptionForm" (submit)="saveFeedbackDescription()">
        <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
            <h4 class="modal-title">Add Feedback Description </h4>
            <button type="button" class="close" (click)="hideFeedbackDescriptionModal()"></button>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-sm-11" style="margin:auto ;">
                            <textarea class="form-control" formControlName="feedback_description" rows="3"></textarea>
                            <div *ngIf="submitted && f1.feedback_description.errors" class="invalid-feedback">
                                <div *ngIf="f1.feedback_description.errors.required">Description is required</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button  type="submit" [disabled]="feedbackDescLoading" class="btn btn-primary" ><i *ngIf="feedbackDescLoading" class="fa fa-spin fa-spinner"></i> 
                    <span>Submit</span>    
                </button>
            <button type="button" class="btn" (click)="hideFeedbackDescriptionModal()">Close</button>
            </div>
        </div>
        </div>
    </form>
</div>